import React from "react";
import { Link } from "gatsby";
import { ArrowRight, Clock } from "lucide-react";

export default function VideoDetails({ video, isMobile = false }) {
  const textSizes = {
    eyebrow: isMobile ? "text-sm" : "text-base",
    episode: isMobile ? "text-sm" : "text-base",
    title: isMobile ? "text-2xl" : "text-3xl",
    description: isMobile ? "text-sm leading-5" : "text-lg leading-7",
    duration: isMobile ? "text-xs" : "text-base",
    button: "text-base",
  };

  const titleTracking = isMobile ? "tracking-[-0.6px]" : "tracking-[-0.75px]";
  const titleLeading = isMobile ? "leading-8" : "leading-9";

  console.log("solit", video.eyebrow.text);
  return (
    <div className={`flex flex-col gap-5 ${isMobile ? "w-full" : "w-[500px]"}`}>
      <div className={`flex flex-col ${isMobile ? "gap-4" : "gap-3"}`}>
        {/* Series and Episode Info */}
        <div className={`flex items-start ${textSizes.eyebrow} font-medium`}>
          <span
            className={`text-[#c5bbff] ${isMobile ? "tracking-[-0.35px]" : "tracking-[-0.4px]"}`}
          >
            {video.eyebrow?.text?.split(" | ")[0]}
          </span>
          {video.eyebrow?.text?.includes(" | ") && (
            <div>
              <span
                className={`text-white/60 mx-1 ${isMobile ? "text-base" : ""}`}
              >
                |
              </span>
              <span className="text-white/60">
                {video.eyebrow.text.split("|")[1]?.trim()}
              </span>
            </div>
          )}
        </div>

        <div className={`text-white/60 ${textSizes.episode} font-medium`}>
          {video.episode_number?.text}
        </div>

        {/* Title */}
        {video.thumbnail_title?.text && (
          <h3
            className={`text-white ${textSizes.title} font-medium ${titleTracking} ${titleLeading}`}
          >
            {video.thumbnail_title?.text}
          </h3>
        )}

        {/* Description */}
        <p className={`text-white/80 ${textSizes.description}`}>
          {video.episode_description?.text || "No description available."}
        </p>

        {/* Duration */}
        {video.episode_duration?.text && (
          <div
            className={`flex items-center ${isMobile ? "gap-1" : "gap-1.5"}`}
          >
            <Clock size={isMobile ? 14 : 18} className="text-white/80" />
            <span className={`text-[#f0f0f0]/80 ${textSizes.duration}`}>
              {video.episode_duration?.text}
            </span>
          </div>
        )}
      </div>

      {/* Watch Button */}
      <Link
        to={video.cta_url?.url || "#"}
        className={`bg-[#f0f0f0] hover:bg-white transition-colors font-manrope rounded-[40px] px-4 py-2 flex items-center gap-2 no-underline ${
          isMobile ? "justify-center w-full" : "w-fit"
        }`}
        aria-label={`Watch ${video.thumbnail_title?.text || "video"}`}
      >
        <span
          className={`text-[#434343] ${textSizes.button} font-semibold tracking-[-0.4px]`}
        >
          {video.cta_copy?.text || "Watch now"}
        </span>
        <ArrowRight size={24} className="text-[#434343]" />
      </Link>
    </div>
  );
}
